import {
  ClassificationIcon,
  FileSize,
  NoData,
  RenderWhen,
  Time
} from "../../../../../components";
import { Schema } from "../../../../samples/@types/common";
import SearchLink from "../../../../search/components/links/SearchLink";
import { EnrichedFile } from "../../../@types/common";
import ThirdPartyReputationStats from "../../../components/common/ThirdPartyReputationStats";
import BulkActions from "../../common/components/actions/BulkActions";
import SingleActions from "../../common/components/actions/SingleActions";
import FileName from "../../common/components/FileName";

type ToggleProps = (values: unknown, name: string) => void;

export const getSchema = (onToggle: ToggleProps): Schema<EnrichedFile> => ({
  fields: [
    {
      name: "status",
      displayTitle: <ClassificationIcon />,
      className: "text-center",
      style: { padding: "10px", width: "3%" },
      component: ({ classification, factor }) => (
        <ClassificationIcon
          classification={classification}
          riskScore={factor}
        />
      )
    },
    {
      name: "name",
      displayTitle: "File Name / Hash",
      style: { width: "28%" },
      component: ({ filename, sha1, classification }) => (
        <FileName
          classification={classification}
          filename={filename ?? ""}
          sha1={sha1}
        />
      )
    },
    {
      name: "last_seen",
      displayTitle: "Last Seen",
      style: { width: "15%" },
      component: ({ last_seen: lastSeen }) => (
        <RenderWhen condition={Boolean(lastSeen)} fallback={<NoData />}>
          <Time time={lastSeen} className="time-exact" withTitle />
        </RenderWhen>
      )
    },
    {
      name: "format",
      displayTitle: "Format",
      style: { width: "15%" },
      className: "overflow-ellipsis",
      component: ({ sample_type: type }) => (
        <SearchLink
          className="underline"
          keyword="TYPE"
          value={type ?? ""}
          data-testid="domain-files-communicating-format-link"
        >
          {type}
        </SearchLink>
      )
    },
    {
      name: "av_detection",
      displayTitle: "AV Detection",
      style: { width: "8%" },
      component: ({ scanner_count: count, scanner_match: match }) => (
        <ThirdPartyReputationStats maliciousCount={match} totalCount={count} />
      )
    },
    {
      name: "threat",
      displayTitle: "Threat",
      style: { width: "17%" },
      className: "overflow-ellipsis",
      component: ({ threat_name: threatName }) => (
        <RenderWhen condition={Boolean(threatName)} fallback={<NoData />}>
          <SearchLink
            className="underline"
            keyword="THREATNAME"
            value={threatName ?? ""}
            data-testid="domain-files-communicating-threat-link"
          >
            {threatName}
          </SearchLink>
        </RenderWhen>
      )
    },
    {
      name: "size",
      displayTitle: "Size",
      style: { width: "7%" },
      component: ({ file_size: size }) => <FileSize value={size} />
    },
    {
      name: "_actions",
      displayTitle: () => (
        <BulkActions
          id="domain-files-communicating-bulk-actions"
          onToggle={onToggle}
        />
      ),
      style: { padding: "10px", width: "3%" },
      component: data => (
        <SingleActions
          id="domain-files-communicating-single-actions"
          data={data}
          onToggle={onToggle}
        />
      )
    }
  ]
});
